interface ReconnectingBannerProps {
  visible: boolean;
}

export function ReconnectingBanner({ visible }: ReconnectingBannerProps) {
  if (!visible) return null;

  return (
    <div className="w-full bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-800 text-xs text-center py-1.5 px-4 mb-2 z-[100]">
      Real-time updates paused. Reconnecting...
    </div>
  );
}
